export type PageTurnDirection = 'prev' | 'next';

export interface Point {
  x: number;
  y: number;
}

export interface BookRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface VisibleBookRectInput {
  canvasWidth: number;
  canvasHeight: number;
  offsetX: number;
  offsetY: number;
  pageWidth: number;
  pageHeight: number;
  scale: number;
  displayMode: 'single' | 'double';
  currentPageIndex: number;
  pageCount: number;
}

const PAGE_EDGE_TRIGGER_RATIO = 0.1;

export const getVisibleBookRect = (input: VisibleBookRectInput): BookRect => {
  const singlePageVisible =
    input.displayMode === 'single' ||
    input.currentPageIndex < 0 ||
    input.currentPageIndex + 1 >= input.pageCount;
  const width = input.pageWidth * (singlePageVisible ? 1 : 2) * input.scale;
  const height = input.pageHeight * input.scale;

  return {
    left: input.canvasWidth / 2 + input.offsetX - width / 2,
    top: input.canvasHeight / 2 + input.offsetY - height / 2,
    width,
    height
  };
};

export const getPageTurnDirection = (
  point: Point,
  bookRect: BookRect,
  pageWidth: number
): PageTurnDirection | null => {
  if (bookRect.width <= 0 || bookRect.height <= 0 || pageWidth <= 0) return null;

  const right = bookRect.left + bookRect.width;
  const bottom = bookRect.top + bookRect.height;
  if (point.y < bookRect.top || point.y > bottom) return null;

  const edgeWidth = pageWidth * PAGE_EDGE_TRIGGER_RATIO;

  // 书本左右外侧空白：点击后走上一页/下一页（与拖拽翻页分区一致）。
  if (point.x < bookRect.left) return 'prev';
  if (point.x > right) return 'next';

  if (point.x <= bookRect.left + edgeWidth) return 'prev';
  if (point.x >= right - edgeWidth) return 'next';
  return null;
};
